document.addEventListener('DOMContentLoaded',()=>{const sticky=document.querySelector('[data-sticky-atc]');if(sticky){const target=document.querySelector('[data-product-form]');const io=new IntersectionObserver(([e])=>sticky.classList.toggle('is-visible',!e.isIntersecting),{threshold:.05});if(target)io.observe(target)}document.querySelectorAll('[data-add]').forEach(btn=>{btn.addEventListener('click',async(e)=>{const id=btn.dataset.variant;if(!id)return;btn.textContent='Ajout...';try{await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id,quantity:1})});btn.textContent='Ajouté';setTimeout(()=>btn.textContent='Ajouter au panier',1200)}catch(err){btn.textContent='Voir produit'}})})});
document.addEventListener('click', function (event) {
  const minusButton = event.target.closest('.quantity-minus');
  const plusButton = event.target.closest('.quantity-plus');

  if (!minusButton && !plusButton) return;

  const control = event.target.closest('.quantity-control');
  if (!control) return;

  const input = control.querySelector('.quantity-input');
  if (!input) return;

  let value = parseInt(input.value, 10) || 0;

  if (minusButton) {
    value = Math.max(0, value - 1);
  }

  if (plusButton) {
    value = value + 1;
  }

  input.value = value;
});